export default function EmpathySection() {
  const pains = [
    {
      title: "デザインを優先すると疲れる",
      desc: "好きなパンプスを履いたら、午後には足が痛くなる。",
    },
    {
      title: "楽さを選ぶと気分が上がらない",
      desc: "機能重視の靴は快適だけど、テンションが下がる。",
    },
    {
      title: "合う靴がなかなか見つからない",
      desc: "試し履きを繰り返しても、なぜかいつもしっくりこない。",
    },
    {
      title: '"しょうがない"と思い続けている',
      desc: "靴が合わないのは、自分の足のせいだと諦めている。",
    },
  ];

  return (
    <section id="about" className="bg-[#FAFAF8] py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        {/* Section header */}
        <div className="max-w-2xl mx-auto text-center mb-16">
          <p
            className="text-[#B8895A] text-xs tracking-widest mb-4 uppercase"
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            Empathy
          </p>
          <h2
            className="text-3xl md:text-4xl font-bold text-[#1C1917] leading-snug mb-6"
            style={{ fontFamily: "'Noto Serif JP', serif" }}
          >
            おしゃれをしたい。
            <br />
            でも、靴はいつも少し我慢している。
          </h2>
          <p
            className="text-[#78716C] text-sm leading-loose"
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            それって、あなたの足が特別なわけではありません。
            <br />
            正しく選べていないだけかもしれません。
          </p>
        </div>

        {/* Pain grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-16">
          {pains.map((item, i) => (
            <div
              key={i}
              className="bg-white rounded-2xl p-6 border border-[#F0EBE3] hover:border-[#E8C99A]/60 transition-all duration-300 group"
            >
              <div className="w-10 h-10 flex items-center justify-center bg-[#F5F0EA] rounded-xl mb-4 group-hover:bg-[#E8C99A]/20 transition-colors">
                <span className="text-[#B8895A] text-sm font-bold" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                  {String(i + 1).padStart(2, "0")}
                </span>
              </div>
              <h3
                className="text-[#1C1917] text-sm font-bold mb-2 leading-snug"
                style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
              >
                {item.title}
              </h3>
              <p
                className="text-[#78716C] text-xs leading-loose"
                style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
              >
                {item.desc}
              </p>
            </div>
          ))}
        </div>

        {/* Pivot - Don't give up */}
        <div className="max-w-2xl mx-auto text-center bg-[#1C1917] rounded-3xl px-8 md:px-16 py-12 relative overflow-hidden">
          <div className="absolute top-0 right-0 w-48 h-48 bg-[#E8C99A]/5 rounded-full -translate-y-16 translate-x-16" />
          <div className="absolute bottom-0 left-0 w-32 h-32 bg-[#E8C99A]/5 rounded-full translate-y-10 -translate-x-10" />
          <div className="relative z-10">
            <p
              className="text-[#E8C99A] text-xs tracking-widest mb-4"
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            >
              でも、きっと
            </p>
            <p
              className="text-white text-xl md:text-2xl font-bold leading-loose mb-3"
              style={{ fontFamily: "'Noto Serif JP', serif" }}
            >
              おしゃれを諦めたくない。
            </p>
            <p
              className="text-white/60 text-sm leading-loose"
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            >
              その気持ちに、ちゃんと応えられる場所があります。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}